import React, { useMemo } from 'react';

// --- ICONOS SVG PREMIUM ---
const IconSiniestro = () => (
    <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
);

const IconPending = () => (
    <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const IconCheck = () => (
    <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const IconBan = () => (
    <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
    </svg>
);

const IconWheel = () => (
    <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 22c5.523 0 10-4.577 10-10S17.523 2 12 2 2 6.577 2 12s4.577 10 10 10zM12 15a3 3 0 100-6 3 3 0 000 6z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v7m0 6v7m-10-10h7m6 0h7" />
    </svg>
);

const IconUser = () => (
    <svg className="w-4 h-4 text-indigo-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);

const IconSettings = () => (
    <svg className="w-4 h-4 text-indigo-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

/**
 * Componente modular de lista analítica operativa
 */
const AnalyticsList = ({ title, icon, data, badgeColor = 'indigo' }) => (
    <div className="bg-white rounded-2xl border border-slate-200/90 shadow-sm overflow-hidden text-left flex flex-col h-full hover:shadow-md transition-all">
        <div className="p-4 px-5 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 font-black text-[10px] text-slate-500 uppercase tracking-widest flex items-center gap-2 select-none">
            {icon} <span>{title}</span>
        </div>
        <div className="divide-y divide-slate-100 max-h-[380px] overflow-y-auto custom-scrollbar">
            {data.length === 0 ? (
                <p className="p-8 text-center text-slate-400 italic text-[11px] select-none">Sin registros</p>
            ) : (
                data.map((row, idx) => (
                    <div key={idx} className="p-4 px-5 flex justify-between items-center hover:bg-slate-50/50 transition-colors">
                        <span className="text-[12px] font-black uppercase text-slate-800 tracking-tight">{row.name}</span>
                        <span className={`px-3 py-1 bg-${badgeColor}-50 text-${badgeColor}-700 rounded-full font-mono text-[10px] font-black border border-${badgeColor}-100`}>
                            {row.cant} {row.cant === 1 ? 'caso' : 'casos'}
                        </span>
                    </div>
                ))
            )}
        </div>
    </div>
);

const KpisSiniestros = ({ registros, isDbLoaded }) => {

    const metrics = useMemo(() => {
        if (!isDbLoaded || !registros || registros.length === 0) return null;

        let cantAbierto = 0; let cantCerrado = 0; let cantRechazado = 0; let cantRoboRuedas = 0;
        const tiposMap = {}; const responsablesMap = {};

        registros.forEach(item => {
            const estado = String(item.estadoGestion || item.estado || 'PENDIENTE').trim().toLowerCase();
            const tipo = String(item.tipoSiniestro || 'SIN ESPECIFICAR').trim().toUpperCase();
            const resp = String(item.quienGestiono || item.quienGestionoSiniestro || item.usuarioId || 'SIN ASIGNAR').trim().toUpperCase();

            if (['abierto', 'abierta', 'pendiente', 'en curso'].includes(estado)) cantAbierto += 1;
            else if (['cerrado', 'cerrada', 'liquidado', 'finalizado'].includes(estado)) cantCerrado += 1;
            else if (['rechazado', 'rechazada', 'sin cobertura'].includes(estado)) cantRechazado += 1;

            if (tipo.includes('RUEDA') || (item.cantidadRuedas && Number(item.cantidadRuedas) > 0)) cantRoboRuedas += 1;
            tiposMap[tipo] = (tiposMap[tipo] || 0) + 1;
            responsablesMap[resp] = (responsablesMap[resp] || 0) + 1;
        });

        return {
            total: registros.length,
            cantAbierto, cantCerrado, cantRechazado, cantRoboRuedas,
            porTipo: Object.entries(tiposMap).map(([name, cant]) => ({ name, cant })).sort((a, b) => b.cant - a.cant),
            porResp: Object.entries(responsablesMap).map(([name, cant]) => ({ name, cant })).sort((a, b) => b.cant - a.cant)
        };
    }, [registros, isDbLoaded]);

    if (!isDbLoaded) return <div className="p-8 text-center text-slate-400 italic text-sm select-none">Cargando siniestros...</div>;
    if (!metrics) return <div className="p-12 text-center text-slate-400 italic text-sm bg-white rounded-2xl border">Sin siniestros registrados.</div>;

    return (
        <div className="space-y-8 text-left animate-fade-in">
            {/* KPI CARDS CON DISTINCIÓN DE COLORES SEMÁNTICOS EN LOS NÚMEROS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
                {[
                    { title: 'Siniestros Totales', val: metrics.total, icon: <IconSiniestro />, color: 'indigo', valColor: 'text-indigo-600' },
                    { title: 'Casos Abiertos', val: metrics.cantAbierto, icon: <IconPending />, color: 'red', valColor: 'text-red-600' },
                    { title: 'Casos Cerrados', val: metrics.cantCerrado, icon: <IconCheck />, color: 'emerald', valColor: 'text-emerald-600' },
                    { title: 'Rechazados', val: metrics.cantRechazado, icon: <IconBan />, color: 'slate', valColor: 'text-slate-500' },
                    { title: 'Robo Ruedas', val: metrics.cantRoboRuedas, icon: <IconWheel />, color: 'amber', valColor: 'text-amber-600' }
                ].map((card, i) => (
                    <div key={i} className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between hover:shadow-md transition-all">
                        <div>
                            <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest select-none">{card.title}</p>
                            <h4 className={`text-2xl font-black mt-1 font-mono ${card.valColor}`}>{card.val}</h4>
                        </div>
                        <span className={`p-3 bg-${card.color}-50 text-${card.color}-600 rounded-xl`}>{card.icon}</span>
                    </div>
                ))}
            </div>

            {/* LISTAS DE DISTRIBUCIÓN */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <AnalyticsList title="Distribución por Tipo de Siniestro" icon={<IconSettings />} data={metrics.porTipo} badgeColor="slate" />
                <AnalyticsList title="Desempeño de Responsables" icon={<IconUser />} data={metrics.porResp} badgeColor="indigo" />
            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar { width: 5px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
                .animate-fade-in { animation: fadeIn 0.25s ease-out forwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
};

export default KpisSiniestros;